import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Eemalda kõik filtrid

  <span style="color:#85c1dc;">**FI:**</span>
  Tyhjennä suodattimet

  <span style="color:#85c1dc;">**RU:**</span>
  Очистить фильтры
*/
/* @__NO_SIDE_EFFECTS__ */
const m1450 = msg(
  mf`Eemalda kõik filtrid`,
  mf`Tyhjennä suodattimet`,
  mf`Очистить фильтры`,
)

export { m1450 as 'filter.clear' }